import React from 'react';
import { Empty } from 'antd';

const EmptyContent = () => {
  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет уведомлений" />
  );
};

export default EmptyContent;
